<form
  [formGroup]="form"
  class="flex flex-col gap-2 w-full">
  @for (day of WEEKDAYS; track $index; let last = $last) {
    <div class="flex flex-col gap-2 w-full">
      <div class="flex items-center gap-1">
        <mat-icon svgIcon="remix:Business/calendar-2-fill" />

        <label
          [for]="day"
          translate
          >{{ dayOfWeekLabel[day] }}</label
        >
      </div>

      @if (getTimeRangesControl(day).controls.length) {
        <div
          class="flex flex-col gap-4 sm:gap-2"
          formArrayName="{{ day }}"
          [id]="day">
          @for (timeRangeCtrl of getTimeRangesControl(day).controls; track $index) {
            <div>
              <div
                class="flex items-center gap-2 w-full"
                [ngClass]="{
                  'sm:border-none m-0 p-0 border rounded border-ruber': getOverlappingIndices(day).includes($index)
                }">
                <rms-timerange
                  [formControl]="timeRangeCtrl"
                  [interval]="interval"
                  class="w-3/4 sm:w-fit button-sm" />
                <button
                  type="button"
                  [class]="variant === 'sm' ? 'button-sm self-start square-button' : 'square-button self-start w-10'"
                  color="primary"
                  (click)="removeTimeRange(day, $index)"
                  mat-button>
                  <mat-icon svgIcon="remix:System/delete-bin-line" />
                </button>
              </div>
              @if (getCombinedErrors(day, $index)) {
                <rms-control-error
                  [errors]="getCombinedErrors(day, $index)"
                  [errorState]="getOverlappingIndices(day).includes($index)" />
              }
            </div>
          }
        </div>
      }

      <button
        type="button"
        [class]="variant === 'sm' ? 'button-sm self-start compact-button square-button' : 'square-button self-start'"
        (click)="addTimeRange(day)"
        mat-stroked-button>
        <mat-icon svgIcon="remix:System/add-line" />
      </button>

      @if (!last) {
        <mat-divider />
      }
    </div>
  }
</form>
